export default __webpack_public_path__ + "static/media/nftdomain.e314d032.png";